
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/search/[...searchTerm]",
      function () {
        return require("private-next-pages/search/[...searchTerm].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/search/[...searchTerm]"])
      });
    }
  